import Table from "../../../../../../../common/components/molecule/Table/Table";
import { StreetLight } from "../../../../../types/streetLight.types";

export interface StreetLightViewProps {
  streetLightList?: StreetLight[] | null;
  isLoading?: boolean;
  onClickItem?: (id: string) => void;
  updateStreetLight?: (id: string) => void;
  deleteStreetLight?: (id: string) => void;
}
export default function StreetLightListView({
  streetLightList,
  isLoading,
  onClickItem,
  updateStreetLight,
  deleteStreetLight,
}: StreetLightViewProps) {
  return (
    <Table
      variant="dark"
      headerTitle={["Nom", "Numéro", "Noeud Zhaga Devui"]}
      isLoading={isLoading}
      bodyData={streetLightList?.map((streetLight) => ({
        id: streetLight.str_light_id,
        data: [streetLight.str_light_name, streetLight.str_light_number, streetLight.str_light_zhaga_devui],
      }))}
      emptyMessage="Aucun lampadaire trouvé"
      onRowClick={(row) => onClickItem && onClickItem(row.id)}
      onEditRow={updateStreetLight ? (row) => updateStreetLight(row.id) : undefined}
      onDeleteRow={deleteStreetLight ? (row) => deleteStreetLight(row.id) : undefined}
    />
  );
}
